<mat-dialog-content class="mat-typography custom-dialog text-center">
  <button
    mat-icon-button
    mat-dialog-close
    class="btn-close"
    *ngIf="!data?.disableClose">
    <mat-icon>close</mat-icon>
  </button>
  <div class="mt-5">
    <img
      src="{{ data.iconSrc }}"
      alt="{{ data.title }} icon"
      aria-hidden="true"
      class="icon-dialog"
      *ngIf="data.iconSrc"
      width="100px"
      height="100px" />
    <mat-progress-spinner
      mode="indeterminate"
      class="mx-auto mb-4"
      *ngIf="data.spinner"></mat-progress-spinner>
    <h2 mat-dialog-title *ngIf="data.title">{{ data.title }}</h2>
    <h4>
      {{ data.message }}
    </h4>
  </div>
</mat-dialog-content>
<mat-dialog-actions
  class="d-flex pb-5 text-center justify-content-center"
  *ngIf="data.cancelText || data.confirmText">
  <button
    mat-stroked-button
    class="mr-3"
    (click)="cancel()"
    color="primary"
    *ngIf="data.cancelText">
    {{ data.cancelText || 'Cancel' }}
  </button>
  <button
    mat-flat-button
    (click)="confirm()"
    color="primary"
    cdkFocusInitial
    *ngIf="data.confirmText">
    {{ data.confirmText }}
  </button>
</mat-dialog-actions>
